// @flow
import RecordRequestService from '../services/record-request-service';
import type { Action } from '../types/actions';

// action creators
function providerStatusRequest(): Action { return { type: 'PROVIDER_STATUS_REQUEST' }; }
function providerStatusSuccess(status): Action { return { type: 'PROVIDER_STATUS_SUCCESS', status }; }
function providerStatusError(error): Action { return { type: 'PROVIDER_STATUS_ERROR', error }; }

function allProviderStatusesRequest(): Action { return { type: 'ALL_PROVIDER_STATUSES_REQUEST' }; }
function allProviderStatusesSuccess(allStatuses): Action {
  return { type: 'ALL_PROVIDER_STATUSES_SUCCESS', allStatuses };
}
function allProviderStatusesError(error): Action { return { type: 'ALL_PROVIDER_STATUSES_ERROR', error }; }

const providerStatus = (id: number) => (dispatch) => {
  dispatch(providerStatusRequest());
  RecordRequestService
    .status(id)
    .then((status) => dispatch(providerStatusSuccess(status)))
    .catch((error) => dispatch(providerStatusError(error)));
};

const allProviderStatuses = (ids: number[]) => (dispatch) => {
  dispatch(allProviderStatusesRequest());
  RecordRequestService
    .allStatus(ids)
    .then((allStatuses) => dispatch(allProviderStatusesSuccess(allStatuses)))
    .catch((error) => dispatch(allProviderStatusesError(error)));
};

export { providerStatus, allProviderStatuses };


// WEBPACK FOOTER //
// ./src/actions/status.js